import { updateUserConfig } from "../services/userService";
import { isEqual, omit } from "lodash";
import { useTutorial } from "../hooks/useTutorial";

export const func_userConfigUpdate = async (
  isTutorial: boolean,
  stage?: number,
  step?: number,
  target_component?: string
) => {
  console.log("target_component", target_component);
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const config = JSON.parse(userInfo.config) || {};
  const tutorial = {
    completed: isTutorial,
    stage: stage || config.tutorial?.stage || 0,
    step: step || config.tutorial?.step || 0,
    lastSeenAt: new Date(),
  };
  const existing = config.tutorial || {};

  if (isEqual(omit(tutorial, ["lastSeenAt"]), omit(existing, ["lastSeenAt"]))) {
    return;
  }
  const newConfig = { ...config, tutorial };

  try {
    await updateUserConfig(newConfig, userInfo.id);
  } catch (error) {
    console.error("Error parsing user config:", error);
  }
  localStorage.setItem(
    "userInfo",
    JSON.stringify({ ...userInfo, config: JSON.stringify(newConfig) })
  );
};

export const saveTutorialProgress = (pathName?: string, index?: number) => {
  // console.log("저장할 pathName: ", pathName);
  // console.log("저장할 index: ", index);
  localStorage.setItem(
    "tutorialProgress",
    JSON.stringify({
      pathname: pathName,
      index,
    })
  );
};

export const getTutorialContinue = () => {
  try {
    const data = localStorage.getItem("tutorialProgress");
    const parsed = JSON.parse(data || "{}");
    if (parsed.play) {
      console.log("튜토리얼 이어서 진행");
    }
    return parsed.play;
  } catch (err) {
    console.warn("localStorage 파싱 실패:", err);
    return false;
  }
};
